import {
  resolveSupportedLocale,
  type SupportedLocale,
} from '@brightdrop/localization-core';
import i18next from 'i18next';

/**
 * Resolves the active UI locale to one the product supports. `i18next.languages`
 * is the active language followed by its fallback chain, and the core only matches
 * exact tags, so a bare `es` lands on `es-MX` through the chain the i18next
 * configuration builds; anything outside the supported set (e.g. the pseudo
 * locale) falls back to the regional default.
 * @returns A supported locale tag such as `es-MX`
 */
export const getActiveLocale = (): SupportedLocale =>
  resolveSupportedLocale(i18next.languages ?? []);
